enum OS {
  Windows = 1,
  Mac = 2,
  Linux = 3,
  Other = 4,
}

interface SystemInformation {
  supportsDarkMode: boolean;
  isDarkMode: boolean;
  scale: number;
  os: OS;
}

function getOS() {
  const userAgent = navigator.userAgent;
  if (userAgent.includes("Win")) return OS.Windows;
  if (userAgent.includes("Mac")) return OS.Mac;
  if (userAgent.includes("Linux")) return OS.Linux;
  return OS.Other;
}

function getSystemInformation(): string {
  const supportsDarkMode = Boolean(window.matchMedia);
  const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const scale = window.devicePixelRatio;
  const os = getOS();
  const info: SystemInformation = {
    supportsDarkMode,
    isDarkMode,
    scale,
    os,
  };
  return JSON.stringify(info);
}

export {
  getOS,
  getSystemInformation,
};
